import { connect } from 'react-redux'
import { FieldTimeOutlined, DatabaseOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Tooltip } from 'antd'

function Timer ({ plugins }) {

  const orchestrator = plugins['weaver-orchestrator']

  const getRunningOpcJobs = async () => {
    const res = await orchestrator.getSchedules();
    const data = JSON.parse(res);
    const opcTasks = data.filter((task) => task.functionalityName === 'pmsccy.opc')
    const promises = opcTasks.map(async({ uid }) => JSON.parse(await orchestrator.getJobs({ scheduleUid: uid })))
    const allOpcJobs =  _.flatten(await Promise.all(promises))
    return allOpcJobs.find(({ status }) => status === 'running') || {}
  }

  const opcRunningJobs = useQuery({
    queryKey: ['opc.running.jobs'],
    queryFn: getRunningOpcJobs,
    refetchInterval: 60000
  })

  const opcInfo = useQuery({
    queryKey: ['opcInfo'],
    queryFn: () => {
      if (!_.isEmpty(opcRunningJobs.data) === true) {
        return { tooltip: 'OPC koppeling is actief.', color: '#52c41a' }
      } else {
        return { tooltip: 'Onderbroken koppeling met OPC.', color: '#eb3c3c' }
      }
    },
    initialData: { tooltip: 'Wordt geladen...', color: '#aaa' },
    enabled: !!opcRunningJobs.data
  })

  const timer = useQuery({
    queryKey: ['timer'],
    queryFn: () => new Weaver.Query(undefined, 'afsluitingen').limit(1).find(),
    refetchInterval: 60000
  })

  const timerHandler = (timerData, opcRunningJobs) => {
    if (_.isEmpty(opcRunningJobs)) {
      return { tooltip: 'Onderbroken koppeling met OPC.', color: '#eb3c3c' }
    }

    const ms = Date.now() - new Date(timerData[0].createdAt())
    const mins = ms / 60000
    return mins > 20 ? {
      tooltip: 'Factuurdata is out of date.',
      color: "#eb3c3c"
    } : {
      tooltip: 'Recente factuurdata.',
      color: "#52c41a"
    }
  }

  const timerInfo = useQuery({
    queryKey: ['timerInfo'],
    queryFn: () => timer.data.length > 0 ? timerHandler(timer.data, opcRunningJobs.data) : { tooltip: 'Afsluitigen branch is empty.', color: "#eb3c3c" },
    initialData: { tooltip: 'Please wait...', color: '#aaa' },
    enabled: (!!timer.data && !!opcRunningJobs.data)
  })

  const renderTimerIcon = () => <FieldTimeOutlined style={{ color: timerInfo.data.color }}/>
  const renderOpcIcon = () => <DatabaseOutlined style={{ color: opcInfo.data.color }}/>

  return (
    <div style={{ float: 'right' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <div>
          <Tooltip title={timerInfo.data.tooltip}>
            { renderTimerIcon() }
          </Tooltip>
        </div>
        <div style={{ padding: '0px 10px' }}>/</div>
        <Tooltip title={opcInfo.data.tooltip} placement="bottomRight">
          { renderOpcIcon() }
        </Tooltip>
      </div>
    </div>
  );
}

const mapStateToProps = ({ explore: { plugins }}) => ({ plugins })
export default connect(mapStateToProps, null)(Timer)
